import { Icon } from './Icon.tsx';

/**
 * 목록 맨 위의 검색창 — C1 · F1.
 *
 * 늘 나와 있습니다. 돋보기를 눌러야 열리는 창으로 두지 않은 것은, 노트가
 * 쌓일수록 조건으로 좁히는 것보다 이름을 아는 한 장을 바로 부르는 일이
 * 잦아지기 때문입니다. 한 번 더 누르게 할 만큼 드문 일이 아닙니다.
 *
 * 돋보기는 칸 안쪽 왼쪽에 둡니다 — 어디부터가 입력인지 보여야 합니다.
 *
 * type 을 search 로 두지 않았습니다. 웹킷이 붙여 주는 지우기 버튼은 웹뷰마다
 * 나타나기도 하고 안 나타나기도 하고 색을 맞출 수도 없어서, 우리 것을 답니다.
 */

interface Props {
  value: string;
  onChange: (value: string) => void;
  /** 무엇을 찾는 칸인지 — 「제목 · 내용 검색」처럼 적습니다 */
  placeholder: string;
}

export function SearchBox({ value, onChange, placeholder }: Props) {
  return (
    <div className="search">
      <Icon name="search" size={15} />
      <input
        className="search__input"
        type="text"
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      {/* 친 글자가 있을 때만. 빈 칸에 ✕ 가 붙어 있으면 무엇을 지우라는 것인지 모릅니다 */}
      {value !== '' && (
        <button
          type="button"
          className="search__clear"
          aria-label="검색어 지우기"
          onClick={() => onChange('')}
        >
          <Icon name="close" size={14} />
        </button>
      )}
    </div>
  );
}
